import { FormattedMessage } from 'react-intl';
import Header from '../../components/DSX/Header';
import { key } from '../../messages';

export function SSOExpired() {
	return (
		<div className="sso-expired">
			<Header value="Session Expired" />
			<h3>
				<FormattedMessage
					id={key((o) => o.containers.singleSignOn.sessionExpired)}
				/>
			</h3>
		</div>
	);
}
